module.exports = __webpack_public_path__ + "img/yongle-logo.70f6f97a.png";